import { ActionKeys } from './constants';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function changeQueryString(queryStringParams: Record<string, any>) {
  return <const>{
    type: ActionKeys.CHANGE_QUERY_PARAMS,
    payload: {
      ...queryStringParams,
    },
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function updateQueryParam(name: string, value: any) {
  return <const>{
    type: ActionKeys.UPDATE_QUERY_PARAM,
    payload: {
      name,
      value,
    },
  };
}

export function updateQueryParams(queryStringParams: { [key: string]: string | number }) {
  return <const>{
    type: ActionKeys.UPDATE_QUERY_PARAMS,
    payload: {
      ...queryStringParams,
    },
  };
}

export function storeCurrentQueryParams() {
  return <const>{
    type: ActionKeys.STORE_CURRENT_QUERY_PARAMS,
  };
}

export function restoreQueryParams() {
  return <const>{
    type: ActionKeys.RESTORE_QUERY_PARAMS,
  };
}

export function removeQueryParam(name: string) {
  return <const>{
    type: ActionKeys.REMOVE_QUERY_PARAM,
    payload: {
      name,
    },
  };
}

export function removeQueryParams(name: string[]) {
  return <const>{
    type: ActionKeys.REMOVE_QUERY_PARAMS,
    payload: {
      name,
    },
  };
}

export type RoutingActions =
  | ReturnType<typeof changeQueryString>
  | ReturnType<typeof updateQueryParams>
  | ReturnType<typeof updateQueryParam>
  | ReturnType<typeof storeCurrentQueryParams>
  | ReturnType<typeof restoreQueryParams>
  | ReturnType<typeof removeQueryParam>;
